import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_form, { value: _ctx.valid }, {
      default: _withCtx(() => [
        _createVNode(_component_v_dialog, {
          modelValue: _ctx.open,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.open) = $event)),
          "max-width": "620px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('calendar.dialog.title')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "4",
                              "align-self": "center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('calendar.dialog.eventName')) + "*", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "8",
                              "align-self": "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                  modelValue: _ctx.eventName,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.eventName) = $event)),
                                  variant: "outlined",
                                  "hide-details": "",
                                  density: "compact",
                                  color: "primary"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "4",
                              "align-self": "center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('calendar.dialog.class')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "8",
                              "align-self": "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_select, {
                                  items: _ctx.classes,
                                  modelValue: _ctx.classIds,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.classIds) = $event)),
                                  "item-title": "className",
                                  "item-value": "classId",
                                  variant: "outlined",
                                  density: "compact",
                                  "hide-details": "",
                                  multiple: "",
                                  chips: "",
                                  color: "primary"
                                }, null, 8, ["items", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "4",
                              "align-self": "center"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.$t('calendar.dialog.allDay')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "8",
                              "align-self": "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_checkbox, {
                                  modelValue: _ctx.isAllDay,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isAllDay) = $event)),
                                  class: "mt-0",
                                  "hide-details": "",
                                  color: "primary"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "4",
                              "align-self": "center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.dialogType == 'create')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t('calendar.dialog.startDateRequired')), 1))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.$t('calendar.dialog.date')), 1))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              cols: "8",
                              "align-self": "center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_date_picker, {
                                  modelValue: _ctx.fromDate,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fromDate) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        (!_ctx.isAllDay)
                          ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  "align-self": "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('calendar.dialog.startTime')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "8",
                                  "align-self": "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _ctx.fromTime,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fromTime) = $event)),
                                      type: "time",
                                      variant: "outlined",
                                      density: "compact",
                                      "hide-details": "",
                                      color: "primary"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.dialogType == 'create' && _ctx.isAllDay)
                          ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  "align-self": "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('calendar.dialog.endDate')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "8",
                                  "align-self": "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_date_picker, {
                                      modelValue: _ctx.toDate,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.toDate) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (!_ctx.isAllDay)
                          ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  "align-self": "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, _toDisplayString(_ctx.$t('calendar.dialog.endTime')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "8",
                                  "align-self": "center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _ctx.toTime,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.toTime) = $event)),
                                      type: "time",
                                      variant: "outlined",
                                      density: "compact",
                                      "hide-details": "",
                                      onInput: _ctx.formatTimeToText,
                                      color: "primary"
                                    }, null, 8, ["modelValue", "onInput"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, null, {
                      default: _withCtx(() => [
                        (_ctx.dialogType == 'create')
                          ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: _ctx.close,
                                  variant: "text",
                                  color: "grey"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('calendar.dialog.cancel')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  onClick: _ctx.addEvent,
                                  disabled: !_ctx.valid,
                                  loading: _ctx.loading,
                                  color: "primary",
                                  variant: "flat"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('calendar.dialog.create')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick", "disabled", "loading"])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_btn, {
                                  onClick: _ctx.close,
                                  variant: "text",
                                  color: "grey"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('calendar.dialog.cancel')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_v_btn, {
                                  onClick: _ctx.deleteEvent,
                                  loading: _ctx.loading,
                                  dark: "",
                                  color: "red",
                                  variant: "flat"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('calendar.dialog.delete')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick", "loading"]),
                                _createVNode(_component_v_spacer),
                                _createVNode(_component_v_btn, {
                                  onClick: _ctx.updateEvent,
                                  disabled: !_ctx.valid,
                                  loading: _ctx.loading,
                                  color: "primary",
                                  variant: "flat"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('calendar.dialog.save')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["onClick", "disabled", "loading"])
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}